import { createAction, props } from '@ngrx/store';
import { IGroupedProducts } from '../models/products.model';

export const loadGroupedCustomerProducts = createAction(
  '[GroupedCustomerProducts] Load GroupedCustomerProducts',
  props<{ request: string }>()
);

export const loadGroupedCustomerProductsSuccess = createAction(
  '[GroupedCustomerProducts] Load GroupedCustomerProducts Success',
  props<{ response: IGroupedProducts[] }>()
);

export const loadGroupedCustomerProductsFailure = createAction(
  '[GroupedCustomerProducts] Load GroupedCustomerProducts Failure',
  props<{ error: Error | any }>()
);


